import * as React from 'react'
import { useCallback, useMemo } from 'react'

import { CustomFieldListItem } from '../CustomFieldListItem'
import type { CustomFieldListProps } from './CustomFieldList'
import { aggregateFieldOptions } from '@user/store/customFields'

const maxCustomFields = 25

export function useData(props: CustomFieldListProps) {
  const { openForm, openDelete, customFields, customFieldOptions } = props

  const remainingFields = maxCustomFields - customFields.length

  const disableAdd = customFields.length === maxCustomFields
  const onClickAdd = useCallback(() => openForm(), [openForm])

  const fieldList = useMemo(
    () =>
      customFields.map((field, index) => {
        const opts = aggregateFieldOptions(field.id, customFieldOptions)

        return (
          <CustomFieldListItem
            key={field.id}
            index={index + 1}
            customField={field}
            customFieldOptions={opts}
            openForm={openForm}
            openDelete={openDelete}
          />
        )
      }),
    [customFieldOptions, customFields, openDelete, openForm],
  )

  return {
    disableAdd,
    maxCustomFields,
    remainingFields,
    fieldList,
    onClickAdd,
  }
}
